import React from "react";
import RippleLoader from "./RippleLoader";

const LoadingCard = () => {
  return (
    <div className="space-y-6">
      <div className="border-2 border-[#afb6b9] rounded-[4px] p-4 space-y-4">
        <RippleLoader width="w-full" />
        <RippleLoader width="w-3/4" />
        <RippleLoader width="w-1/2" />
        <RippleLoader width="w-1/4" />
      </div>
    </div>
  );
};

export default LoadingCard;
